import styled from "styled-components";
import { InputNumber } from "antd";

export const ProficiencyInputStyled = styled(InputNumber)`
  width: 64px;
`;

// ─── Antd Tooltip style config ────────────────────────────────────────────────

export const INVALID_TOOLTIP_STYLE = {
  overlayInnerStyle: { padding: "6px 10px" },
  overlayStyle: { maxWidth: 280 },
};
